import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteJobTitle as apiForceDelete } from "../../api/apiJobTitles";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteJobTitle() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteJobTitle, isPending: isForceDelete } = useMutation({
        mutationFn: (id) => apiForceDelete(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["jobTitles"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteJobTitle, isForceDelete };
}
